import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectState } from '../../store/slices/themeSlice'
import useCustomStyles from '../../hooks/useCustomStyles'
import { accessCodesStyles } from '../../assets/styles/accessCodesStyles'
import TableWithSearch from './components/TableWithSearch'
import {
  FINANCIAL_INSTITUTION_COLUMNS,
  withDescriptions,
} from '../../utils/columnDescriptions'
import {
  fetchLastUpdatedInstitutions,
  FinancialInstitutionsType,
} from '../../api/awsApis'

type FIKey = keyof FinancialInstitutionsType

const FinancialInstitutions = () => {
  const { theme } = useSelector(selectState)
  const classes = useCustomStyles(accessCodesStyles, theme)
  const [financialInstitutions, setFinancialInstitutions] = useState<
    FinancialInstitutionsType[]
  >([])
  const [loading, setLoading] = useState(true)
  const columns = [
    { key: 'providerName' as FIKey, label: 'Provider Name' },
    { key: 'country' as FIKey, label: 'Country' },
    { key: 'updatedAt' as FIKey, label: 'Updated' },
    { key: 'status' as FIKey, label: 'Status' },
  ]

  //fetch financial institutions from API-fetchLastUpdatedInstitutions()
  useEffect(() => {
    const fetchFinancialInstitutions = async () => {
      try {
        const apiCall = await fetchLastUpdatedInstitutions()
        console.log('API Call Response:', apiCall)
        setFinancialInstitutions(apiCall.response ?? [])
      } catch (error) {
        console.error('Error fetching financial institutions:', error)
      } finally {
        setLoading(false)
      }
    }
    fetchFinancialInstitutions()
  }, [])
  return (
    <div className={classes.container}>
      <div className={classes.tableContainer}>
        <h2 className={classes.header}>FINANCIAL INSTITUTIONS</h2>
      </div>
      <TableWithSearch
        columns={withDescriptions(columns, FINANCIAL_INSTITUTION_COLUMNS)}
        data={financialInstitutions}
      />
    </div>
  )
}

export default FinancialInstitutions
